module.exports = __webpack_public_path__ + "static/media/analytics.70ea7d25.svg";